module.exports = __webpack_public_path__ + "static/media/no-game-img.84e6897d.jpg";